import KOLShop from '../containers/KOLShop'
import KOLProduct from '../containers/KOLProduct'
import ProductDetail from '@/Product/containers/ProductDetail'
import PackageDetail from '@/Package/containers/PackageDetail'
import Shop from '../containers/Shop'
export default {
  path: '/shop',
  name: 'Shop',
  redirect: '/shop/list',
  component: Shop,
  children: [{
    path: 'list',
    name: 'KOL Shop',
    component: KOLShop,
    props: true
  },
  {
    path: 'detail',
    name: 'KOL Product',
    component: ProductDetail,
        props: true,

  },
  {
    path: 'package',
    name: 'KOL Package',
    component: PackageDetail,
    props: true,

  },
  

  ]
}


// WEBPACK FOOTER //
// ./src/Shop/route/index.js